import React from 'react';
import PageHero from 'components/PageHero';

const NotFound = () => {
    return (
        <PageHero
            eyebrow="Errore 404"
            title="Pagina non trovata"
            lead="L’indirizzo non esiste o è stato spostato. Torna alla home oppure contattaci: ti aiutiamo a trovare quello che cerchi."
            primaryCta={{ href: '/', label: 'Torna alla home' }}
            secondaryCta={{ href: '/contacts', label: 'Contattaci' }}
        />
    );
};

export default NotFound;
